export default "__VITE_ASSET__DCsoYR14__"